import React from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import {viewModes, ViewMode} from "../types";

interface Props {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export default function BatchSelector({viewMode, setViewMode}: Props) {
  return (
    <div>
      <div>Settings</div>
      <FormControl>
        <InputLabel id="view_mode-label">View Mode</InputLabel>
        <Select
          style={{width: "10em"}}
          value={viewMode}
          onChange={event => setViewMode(event?.target.value as ViewMode)}
        >
          {viewModes.map(mode => (
            <MenuItem key={mode} value={mode}>
              {nicenText(mode)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

function nicenText(text: string): string {
  return text
    .split("_")
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}
